"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchTerminateContractService = exports.fetchOperationalDateService = exports.changeContractService = exports.fetchProductContractService = void 0;
var index_1 = require("../index");
var axiosInstance_1 = __importDefault(require("../helper/axiosInstance"));
var productContract_1 = __importDefault(require("../models/productContract"));
var accountLine_1 = __importDefault(require("../models/accountLine"));
var common_1 = require("./common");
function fetchProductContractService(productContractId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, url, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error("No urls config found");
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    route = "/cont/contracts/productContracts/".concat(productContractId);
                    url = "".concat(index_1.urlsConfig.values.BASE_URL).concat(route);
                    return [4 /*yield*/, axiosInstance_1.default.get(url, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, new productContract_1.default(response.data)];
            }
        });
    });
}
exports.fetchProductContractService = fetchProductContractService;
function changeContractService(contractId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error("No urls config found");
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    route = "/cont/contracts/productContracts/".concat(contractId);
                    return [4 /*yield*/, axiosInstance_1.default.get("".concat(index_1.urlsConfig.values.BASE_URL).concat(route), config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, new productContract_1.default(response.data)];
            }
        });
    });
}
exports.changeContractService = changeContractService;
// methode pour recupere la date de paiement d'une facture avec refere de la facture
function fetchOperationalDateService(reference, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error("No urls config found");
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    route = "/accountline/".concat(reference, "/operationaldate");
                    return [4 /*yield*/, axiosInstance_1.default.get("".concat(index_1.urlsConfig.values.CONTRACT_BASE_URL).concat(route), config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, new accountLine_1.default(response.data)];
            }
        });
    });
}
exports.fetchOperationalDateService = fetchOperationalDateService;
/**
 * Résiliation de contrat
 * @param terminateContractPayload Le nouvel index renseigné par le client
 * @param token Token keycloak pour l'authentification
 */
function fetchTerminateContractService(terminateContractPayload, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, url, response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat(token),
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    route = token
                        ? "/contracts/product_contracts/terminate"
                        : "/contracts/terminate";
                    if (!index_1.urlsConfig.values)
                        throw Error("No urls config found");
                    url = token
                        ? "".concat(index_1.urlsConfig.values.CONTRACT_BASE_URL).concat(route)
                        : "".concat(index_1.urlsConfig.values.ADMIN_URL).concat(route);
                    return [4 /*yield*/, axiosInstance_1.default.post(url, terminateContractPayload, config)];
                case 2:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, true];
                case 3:
                    e_1 = _a.sent();
                    throw e_1;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.fetchTerminateContractService = fetchTerminateContractService;
